@use '@fukuri-admins/ui/layout' as *;

.checkboxWrapper {
  display: flex;
  flex-direction: column;
  gap: spacing('2');
}

.checkboxRow {
  display: flex;
  align-items: center;
  gap: spacing('8');
}

.checkboxRoot {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  width: 16px;
  height: 16px;

  background: background('Primary');
  border: 1px solid border('Quaternary');
  border-radius: borderRadius('sm');
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px border('Focus');
  }

  &[data-state='checked'] {
    background-color: background('Gray_Darken');
    border-color: border('Gray_Darken');
  }

  &[data-disabled] {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.checkboxIndicator {
  display: flex;
  align-items: center;
  justify-content: center;
  color: text('White');

  // CheckIcon のサイズ調整（10px × 10px に縮小してチェックボックス枠に合わせる）
  // .svgIcon の color: text('High') を上書きし、親 .checkboxIndicator の color を継承させる
  svg {
    width: 10px;
    height: 10px;
    stroke-width: 2.5;
    color: currentColor;
  }
}

.checkboxLabel {
  @include typography('Jp/14_W3');
  color: text('High');
  cursor: pointer;
}

.checkboxDescription {
  @include typography('Jp/12_W3');
  color: text('Low');
  // チェックボックス(16px) + gap(8px) 分インデント
  padding-left: spacing('24');
}
